import { atomWithStorage } from 'jotai/utils'

export const chatLocalMutesAtom = atomWithStorage(
  'chatLocalMutes',
  new Set<string>(),
  {
    getItem: () => {
      const itemFromStorage = localStorage.getItem('chatLocalMutes')
      if (!itemFromStorage) return new Set<string>()
      const deserializedItemFromStorage = JSON.parse(
        itemFromStorage,
      ) as string[]
      return new Set(
        Array.isArray(deserializedItemFromStorage)
          ? deserializedItemFromStorage
          : null,
      )
    },
    setItem: (key, newValue) => {
      localStorage.setItem(
        'chatLocalMutes',
        JSON.stringify(newValue.size ? Array.from(newValue) : []),
      )
    },
    removeItem: () => {
      localStorage.removeItem('chatLocalMutes')
    },
  },
)
